import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    avilableFetureLabel = "avilableFetureLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.avilableFetureLabel]: string;
    };
}
type Props = OwnProps & HasProduct;

export interface ProductDetailsTotalAvilableFuture {
    totalAvilableFutureContainer?: InjectableCss;
    totalAvilableFutureLabel?: InjectableCss;
    totalAvilableFutureValue?: InjectableCss;
}

export const totalAvilableFutureStyles: ProductDetailsTotalAvilableFuture = {
    totalAvilableFutureContainer: {
        css: css`
        font-weight: 600;
        font-size: .9rem !important;
        margin-bottom: .6rem;
        font-family: 'Lato', sans-serif;
        display:flex;
        color: ${themeColors.colorCharcoalGrey};
        `,
    },
    totalAvilableFutureLabel: {
        css: css`
        margin-right:.5rem;
        display:flex;
        `,
    },
    totalAvilableFutureValue: {
        css: css`
        color: #333F48;
        font-family: 'Lato', sans-serif;
        font-weight:400;
        display:flex;
        `,
    },
};

const styles = totalAvilableFutureStyles;

const ProductDetailsTotalAvailableFuture: React.FC<Props> = ({ fields, product }) => {
    if (!product) {
        return null;
    }

    if (product.properties.totalAvailableFuture) {
        return (
            <>
                <StyledWrapper {...styles.totalAvilableFutureContainer}  className="total-future-available">
                    <Typography {...styles.totalAvilableFutureLabel}>
                        {fields.avilableFetureLabel || translate("Total Avilable Future :")}
                    </Typography>
                    <Typography {...styles.totalAvilableFutureValue}>
                        {FormattedCommaSeparatedValue(product.properties.totalAvailableFuture)}
                    </Typography>
                </StyledWrapper>
            </>
        );
    }

    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsTotalAvailableFuture),
    definition: {
        displayName: "Total Avilable Future Property",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.avilableFetureLabel,
                editorTemplate: "TextField",
                defaultValue: "Total Avilable Future :",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
